// Mock market data for instruments
export const mockMarkets = [
  {
    id: 'BTCUSD',
    symbol: 'BTC/USD',
    name: 'Bitcoin',
    price: 43250.32,
    change24h: 3.45,
    volume: '28.5B',
    sparklineData: [
      42000, 42100, 41950, 42200, 42500, 42300, 42800, 43100, 43000, 43250
    ]
  },
  {
    id: 'ETHUSD',
    symbol: 'ETH/USD',
    name: 'Ethereum',
    price: 2285.67,
    change24h: -1.23,
    volume: '12.3B',
    sparklineData: [
      2320, 2310, 2300, 2295, 2280, 2290, 2285, 2290, 2288, 2286
    ]
  },
  {
    id: 'AAPL',
    symbol: 'AAPL',
    name: 'Apple Inc.',
    price: 178.45,
    change24h: 2.15,
    volume: '58.2M',
    sparklineData: [
      175, 175.5, 176, 176.8, 177.2, 177.5, 177.8, 178.1, 178.3, 178.45
    ]
  },
  {
    id: 'SPX',
    symbol: 'SPX',
    name: 'S&P 500',
    price: 4567.89,
    change24h: 0.87,
    volume: '3.2B',
    sparklineData: [
      4530, 4535, 4540, 4545, 4550, 4555, 4560, 4563, 4565, 4568
    ]
  },
  {
    id: 'EURUSD',
    symbol: 'EUR/USD',
    name: 'Euro / US Dollar',
    price: 1.0875,
    change24h: -0.34,
    volume: '142B',
    sparklineData: [
      1.0890, 1.0888, 1.0885, 1.0880, 1.0878, 1.0876, 1.0874, 1.0875, 1.0876, 1.0875
    ]
  },
  {
    id: 'GOLD',
    symbol: 'XAU/USD',
    name: 'Gold',
    price: 2024.50,
    change24h: 1.52,
    volume: '28.7B',
    sparklineData: [
      2010, 2012, 2015, 2017, 2019, 2020, 2021, 2022, 2023, 2024.5
    ]
  }
]

// Generate realistic price variations
export const generatePriceUpdate = (currentPrice, volatility = 0.002) => {
  const change = (Math.random() - 0.5) * 2 * volatility * currentPrice
  return parseFloat((currentPrice + change).toFixed(2))
}
